__turbopack_context__.v({
  "jobs": "jobs-az-module__duYwna__jobs",
  "jobs_buttons": "jobs-az-module__duYwna__jobs_buttons",
  "jobs_item": "jobs-az-module__duYwna__jobs_item",
  "jobs_list": "jobs-az-module__duYwna__jobs_list",
  "role_title": "jobs-az-module__duYwna__role_title",
});
